<template>
  <v-row class="mx-0 px-0 dense pb-0">
    <v-col cols="12" md="8" class="pb-0 px-0">
      <v-card flat class="grey lighten-4 px-4 mb-8">

        <SocialTextFields :required-rules="requiredRules" title="Facebook" icon="facebook-icon.svg" label="Facebook"
                          :value="currentSpeaker.facebook" :url-prefix="urlPrefixes.facebookUrlPrefix"
                          :can-disabled="true"
                          @input="currentSpeaker.facebook=$event"
        />
        <SocialTextFields :required-rules="requiredRules" title="Instagram" icon="instagram-icon.svg"
                          label="Instagram" :value="currentSpeaker.instagram"
                          :url-prefix="urlPrefixes.instagramUrlPrefix" :can-disabled="true"
                          @input="currentSpeaker.instagram=$event"
        />
        <SocialTextFields :required-rules="requiredRules" title="Twitter" icon="twitter-icon.svg" label="Twitter"
                          :value="currentSpeaker.twitter" :url-prefix="urlPrefixes.twitterUrlPrefix"
                          :can-disabled="true"
                          @input="currentSpeaker.twitter=$event"
        />
        <SocialTextFields :required-rules="requiredRules" title="LinkedIn" icon="linkedin-icon.svg" label="LinkedIn"
                          :value="currentSpeaker.linkedin" :url-prefix="urlPrefixes.linkedinUrlPrefix"
                          :can-disabled="true"
                          @input="currentSpeaker.linkedin=$event"
        />
        <SocialTextFields :required-rules="requiredRules" title="YouTube" icon="youtube-icon.svg" label="YouTube"
                          :value="currentSpeaker.youtube" :url-prefix="urlPrefixes.youtubeurlPrefix"
                          :can-disabled="true"
                          @input="currentSpeaker.youtube=$event"
        />
        <SocialTextFields :required-rules="requiredRules" title="Podcast" icon="podcast-icon.svg" label="Podcast"
                          :value="currentSpeaker.podcast" :url-prefix="urlPrefixes.urlPrefix" :can-disabled="true"
                          @input="currentSpeaker.podcast=$event"
        />
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import SocialTextFields from "@/components/MultiConnect/Sponsors/SocialTextFields.vue";
import {mapGetters} from "vuex";

export default {
  name: 'EditSpeakerSocials',
  components: {SocialTextFields},
  computed: {
    ...mapGetters(["urlPrefixes", "currentSpeaker"]),
  },
  data() {
    return {
      requiredRules: [(v) => !!v || "This field is required"],
    }
  }
}
</script>